import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

declare var jQuery:any;
@Component({
  selector: 'app-revolution-slider-wp',
  templateUrl: './revolution-slider-wp.component.html',
  styleUrls: ['./revolution-slider-wp.component.scss']
})
export class RevolutionSliderWpComponent implements OnInit {
  public isApp = new BehaviorSubject<boolean>(false);
  constructor(private route:ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const type = params['type'];
      console.log('type', type);
        if (type === 'app') {
          this.isApp.next(true);
        } else {
          this.isApp.next(false);
        }
        
      });
  }
  ngAfterViewInit(): void {
    jQuery(document).ready(() => {
      jQuery('#rev_slider_4_1').show().revolution({
        jsFileLocation: 'js/',
        sliderLayout: 'fullwidth',
        visibilityLevels: '1240,1024,778,480',
        gridwidth: '1440,1024,778,480',
        gridheight: '900,600,600,400',
        spinner: 'spinner0',
        editorheight: '900,600,600,400',
        responsiveLevels: '1240,1024,778,480',
        disableProgressBar: 'on',
        navigation: {
          onHoverStop: false
        },
        fallbacks: {
          allowHTML5AutoPlayOnAndroid: true
        },
      });
    });
  }
}
